import React from 'react';
import styled from 'styled-components';
import Options from './Options';
import { QuestionProps } from '../../types';

const QuestionContainer = styled.div`
  margin-bottom: 3.2rem;
`;

const QuestionText = styled.h4`
  font-size: 2.6rem;
  font-weight: 500;
  margin-bottom: 2.4rem;
  line-height: 1.4;
  font-family: var(--font-secondary);
  color: var(--color-darkest);
  letter-spacing: 0.5px;
`;

const Question: React.FC<QuestionProps> = ({ question, onNewAnswer, answer }) => {
  return (
    <QuestionContainer>
      <QuestionText>{question.question}</QuestionText>
      <Options
        question={question}
        onNewAnswer={onNewAnswer}
        answer={answer}
      />
    </QuestionContainer>
  );
};

export default Question;
